window.addEventListener('turbolinks:load', () => {
  const flashBox = document.querySelector(".flash-box")
  if (flashBox) {
    setTimeout(() => {
      flashBox.classList.add("-hide")
    }, 2000);
  }
})